<template>
	<div
		v-if="postId"
		class="ratings-row"
	>
		<h3 class="ratings-section-title mb-[12px]">
			How much has this post helped you?
		</h3>

		<div
			id="ratings-component"
			class="ratings-container"
		>
			<div
				class="ratings"
				@mouseout="outHoverStar"
			>
				<span
					v-for="(star, key) in 5"
					:id="`star-rating-${star}`"
					:key="key"
					:class="`star ${rating >= star ? 'filled' : 'unfilled'}`"
					@click="postRating(key + 1)"
					@mouseenter="onHoverStar(key)"
				>
					<svg
						v-if="rating >= star"
						xmlns="http://www.w3.org/2000/svg"
						height="16px"
						viewBox="0 0 24 24"
						width="16px"
						fill="#000000"
					>
						<path
							d="M0 0h24v24H0z"
							fill="none"
						/>
						<path
							d="M0 0h24v24H0z"
							fill="none"
						/>
						<path
							d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
						/>
					</svg>
					<!-- <img
              src="/images/star.svg"
              width="16"
              height="16"
              alt="rating-star"
            /> -->

					<svg
						v-else
						xmlns="http://www.w3.org/2000/svg"
						height="16px"
						viewBox="0 0 24 24"
						width="16px"
						fill="#000000"
					>
						<path
							d="M0 0h24v24H0z"
							fill="none"
						/>
						<path
							d="M0 0h24v24H0z"
							fill="none"
						/>
						<path
							d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
						/>
					</svg>
				</span>
			</div>
			<div class="ratings-metadata">
				({{ rating_count }} votes, average: {{ rating }} out of 5)
			</div>
		</div>
	</div>
</template>

<script setup>
const router = useRoute();
const config = useRuntimeConfig();
const rating = ref(0);
const rating_count = ref(0);
const v4 = ref(
	crypto.randomUUID
		? crypto.randomUUID()
		: Date.now().toString() + Math.random().toString(36).substr(2, 9)
);
const { postId } = defineProps({
	postId: {
		type: Number,
		required: true
	}
});
const getPostRatings = (postId) => {
	return $fetch(
		`${config.public.ratings_url}/ratings/${postId}/get_rating?wid=timothysykes_com`,
		{
			headers: {
				"x-mprtgs-token": config.public.ratings_key
			}
		}
	);
};

const updateRating = async (newRate) => {
	const data = await getPostRatings(postId);
	rating.value = newRate ? rating.value + newRate : data.rating;
	rating_count.value = newRate ? data.post_count + 1 : data.post_count;
};

const postRating = async (rate) => {
	const body = {
		web_id: "timothysykes_com",
		post_id: postId,
		session_id: v4.value,
		ip_address: "192.168.33.25",
		value: rate,
		metadata: ""
	};

	try {
		const res = await fetch(
			`https://kkm2vrodv0.execute-api.us-east-1.amazonaws.com/prod/ratings/create`,
			{
				method: "POST",
				body: JSON.stringify(body),
				headers: {
					"x-mprtgs-token": "vY63uHaVW-Af_arh3pM*wjmra9ysYYrgyX*Nx2MM"
				}
			}
		);

		if (res.status) {
			await updateRating();
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e);
	}
};

onMounted(async () => {
	if (process.client && postId) {
		try {
			const data = await getPostRatings(postId);

			if (data) {
				rating.value = data.rating || 0;
				rating_count.value = data.post_count || 0;
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e);
		}
	}
});

watch(
	() => router.fullPath,
	async (newPath) => {
		try {
			if (process.client && newPath) {
				await updateRating();
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e);
		}
	}
);

const onHoverStar = (index) => {
	const stars = document.querySelectorAll(".ratings .star");

	[...stars].forEach((star, key) => {
		if (index >= key) {
			star.classList.add("hover");
		}
	});

	event.preventDefault();
	event.stopPropagation();
};

const outHoverStar = () => {
	const stars = document.querySelectorAll(".ratings .star");
	[...stars].forEach((star) => {
		star.classList.remove("hover");
	});
};
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

.ratings-row {
	margin-left: 0;
	margin-right: 0;
}

.star.unfilled svg {
	fill: #bdbdbd;
}

.ratings-metadata {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 16px;
	font-weight: 400;
}

.ratings-section-title {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 16px;
	font-weight: 400;
	line-height: 150%;

	@media (min-width: 768px) {
	}
}

.ratings {
	display: flex;
}

.ratings-container {
	display: flex;
	align-items: center;
	column-gap: 16px;
}

.star {
	cursor: pointer;
}

.star svg {
	fill: #f7b230;
	cursor: pointer;
	pointer-events: none;
	&:hover {
		fill: rgb(0, 236, 165);
	}
	&:hover {
		fill: rgb(0, 236, 165);
	}
}
.star.hover svg {
	fill: rgb(0, 236, 165);
}

.content-row {
	padding-right: 16px;
	padding-left: 16px;

	@media (min-width: 800px) {
	}
}
</style>
